import { getToken } from "../../../util/Cookies";

import axiosInstance from "../../../util/axiosInstance";


export const myorderslist = async () => {
  try {


    const response = await axiosInstance.get("/orders/myordersgrouped", {});

    return response.data; // only return useful data
  } catch (error) {
    if (error.response) {
      // server responded but with an error status
      console.error("API error:", error.response.data);
      throw new Error(
        error.response.data.message ||
          `Request failed with status ${error.response.status}`
      );
    } else if (error.request) {
      // request was sent but no response
      console.error("No response received:", error.request);
      throw new Error("No response from server. Please try again later.");
    } else {
      // other errors (e.g., code bug, network issues)
      console.error("Unexpected error:", error.message);
      throw new Error(error.message || "Unexpected error occurred.");
    }
  }
};
